import { render, staticRenderFns } from "./top-link.vue?vue&type=template&id=5ed04154&scoped=true"
import script from "./top-link.vue?vue&type=script&lang=js"
export * from "./top-link.vue?vue&type=script&lang=js"
import style0 from "./top-link.vue?vue&type=style&index=0&id=5ed04154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed04154",
  null
  
)

export default component.exports